// The booking wizard's wording in English, the key list every other locale file matches.
export const en = {
  // Page
  schedule_appointment: "Schedule appointment",
  powered_by: "Powered by",

  // Patient type
  new_or_existing: "Are you a new or existing patient?",
  new_patient: "New patient",
  existing_patient: "Existing patient",
  first_time_visiting: "First time visiting this office",
  been_here_before: "I've been here before",

  // Appointment info
  what_type: "What type of appointment?",
  no_types_available: "No appointment types available for online scheduling at this time.",
  minutes: "%{count} minutes",
  additional_info: "What issue or concern would you like to address?",
  describe_concern: "Please describe your concern...",

  // Provider
  pick_provider: "Pick a provider",
  loading_providers: "Loading providers...",
  failed_load_providers: "Failed to load providers. Please try again.",
  any_provider: "Any provider",
  show_all_available: "Show all available times",
  no_availability: "No availability",

  // Time
  pick_a_time: "Pick a time",
  finding_times: "Finding available times...",
  no_times_for_date: "No times available for this date",
  slot_just_taken: "Sorry, that time was just taken. Please pick another.",
  jump_to_next: "Jump to next available",
  morning: "Morning",
  afternoon: "Afternoon",
  cant_find_time: "Can't find a time slot? Call our office and we'll help you find one.",

  // Patient info
  your_information: "Your information",
  first_name: "First name",
  last_name: "Last name",
  preferred_name: "Preferred name",
  optional: "Optional",
  date_of_birth: "Date of birth",
  phone_number: "Phone number",
  required: "Required",
  invalid_phone: "Enter a valid 10-digit phone number",
  min_age: "Patient must be at least 5 years old",
  future_date: "Can't be in the future",
  referral_question: "How did you find out about us?",
  referral_prompt: "Select an option",
  referral_detail_who: "Who referred you?",
  referral_detail_other: "Please tell us how you found out about us",
  referral_detail_optional: "Additional details (optional)",
  verification_disclaimer: "A verification code will be sent to this number.",
  phone_verified: "Phone verified",
  verifying: "Verifying...",
  verify: "Verify",
  invalid_code: "Invalid code. Please try again.",
  sending: "Sending...",
  resend_code: "Resend code",
  email: "Email",
  send_verification: "Send verification code",
  sending_code: "Sending code...",

  // Insurance
  insurance_info: "Insurance information",
  have_insurance: "Do you have insurance?",
  insurance_changed: "Has your insurance changed since your last visit?",
  no_insurance_change: "No change",
  yes: "Yes",
  no: "No",
  insurance_name: "Insurance name",
  subscriber_name: "Subscriber name",
  subscriber_dob: "Subscriber date of birth",
  subscriber_id: "Subscriber ID",
  group_number: "Group number",
  select_option: "Please select an option",
  card_photo_title: "Photo of your insurance card",
  card_photo_hint:
    "Add photos of both sides of your card so we can check your coverage before your visit.",
  card_front: "Front of card",
  card_back: "Back of card",
  add_photo: "Add photo",
  uploading_photo: "Uploading photo...",
  remove_photo: "Remove",
  card_upload_failed: "We couldn't add the photo. You can try again or continue without it.",
  card_try_again: "Try again",

  // Review
  review_appointment: "Review your appointment",
  appointment_details: "Appointment details",
  type_label: "Type",
  provider: "Provider",
  any_available: "Any available",
  date_and_time: "Date & time",
  notes: "Notes",
  patient_information: "Patient information",
  name: "Name",
  phone: "Phone",
  insurance: "Insurance",
  subscriber: "Subscriber",
  subscriber_id_label: "Subscriber ID",
  group_hash: "Group #",
  no_insurance: "No insurance",
  card_photos: "Card photos",
  card_front_short: "Front",
  card_back_short: "Back",
  waitlist: "Contact me if earlier times become available",
  consent_prefix: "By scheduling, you agree to our ",
  terms: "Terms and Conditions",
  consent_and: " and ",
  privacy: "Privacy Policy",
  consent_suffix:
    ". By providing your phone number, you consent to receive text messages. Message and data rates may apply.",
  scheduling: "Scheduling...",
  schedule_appointment_btn: "Schedule appointment",
  continue_to_payment: "Continue to payment",

  // Deposit
  deposit_title: "Pay your deposit",
  deposit_explainer:
    "A %{amount} deposit confirms this appointment. It will be credited to your account and applied to your visit. If you do not show up for your appointment, you will lose your deposit.",
  deposit_due: "Deposit",
  deposit_card_fee: "Card fee",
  deposit_card_fee_notice:
    "Credit card payments include a %{percentage}% processing fee. Debit cards are not charged a fee.",
  deposit_total: "Total",
  deposit_loading: "Loading secure payment...",
  deposit_paying: "Processing...",
  deposit_pay_and_book: "Pay and book",
  deposit_card_error: "We could not take your deposit. Please check your card and try again.",
  deposit_unavailable: "Secure payment could not be loaded. Please call the office.",
  deposit_needs_hold: "We could not reserve this time. Please pick a time again.",
  deposit_processing:
    "Your payment is still being confirmed. Do not pay again — the office will confirm your appointment shortly.",

  // Confirmation
  appointment_requested: "We received your appointment request!",
  confirm_message:
    "The office will review it and send you a confirmation. If we need any additional information, our team will reach out.",
  date: "Date",
  time: "Time",
  add_to_google: "Add to Google Calendar",
  download_ics: "Download calendar file (.ics)",
  questions_call: "Questions? Call us at",

  // Errors
  network_error: "Something went wrong. Please try again.",

  // Common
  back: "Back",
  continue: "Continue",
  review: "Review",

  // Step labels
  step_appointment: "Appointment",
  step_provider: "Provider",
  step_time: "Time",
  step_your_info: "Your info",
  step_insurance: "Insurance",
} as const;
